import React from 'react';
import logo from '../assets/images/icone/S TRANSP 3.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/footer.css';

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-content">
        <p className="copyright">Photography By </p>
        <img 
          src={logo} 
          className="image-small" 
          alt="Susan Oliveira Logo"
          width="50"
          height="auto"
          loading="lazy"
        />
        <div className="social-links">
          <a 
            href="tel:+351914108774" 
            className="social-icon"
            aria-label="Telefone"
          >
            <FontAwesomeIcon icon={faPhone} />
          </a>
          <a 
            href="mailto:susanoliveirasg@gmail.com" 
            className="social-icon"
            aria-label="Email"
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        </div>
        <p className="copyright1">
          Made By{' '}
          <a 
            href="https://jessicamaximo23.github.io/JessicaMaximoPortfolio/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-icon1"
          >
            Jéssica Máximo
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;